

// export type LearnerTitle = "Emerging Leader" | "Strategic Leader" | "Visionary Leader";
export type LearnerTitle = "Emerging People Leader" | "Effective People Leader" | "Impact‑Driven People Leader";

export type ScoreTag = "Fair" | "Skilled" | "Pro";

// Editable score configuration
export const scoreConfig = {
  titles: [
    // { min: 9, title: "Visionary Leader" as LearnerTitle },
    // { min: 7, title: "Strategic Leader" as LearnerTitle },
    // { min: 0, title: "Emerging Leader" as LearnerTitle },
    { min: 9, title: "Impact‑Driven People Leader" as LearnerTitle },
    { min: 7, title: "Effective People Leader" as LearnerTitle },
    { min: 0, title: "Emerging People Leader" as LearnerTitle },
  ],
  tags: [
    { min: 9, tag: "Pro" as ScoreTag },
    { min: 7, tag: "Skilled" as ScoreTag },
    { min: 0, tag: "Fair" as ScoreTag },
  ],
};

export interface CompetencyScore {
  name: string;
  icon: string;
  score: number;
  tag: ScoreTag;
}

export interface LearnerReport {
 
  title: LearnerTitle;
  overallScore: number;
  commentary: any;
  reportData?: any;
  competencies: CompetencyScore[];
}

// Helper to determine title based on score
export function getTitleFromScore(score: number): LearnerTitle {
  for (const tier of scoreConfig.titles) {
    if (score >= tier.min) return tier.title;
  }
  return "Emerging People Leader";
}

// Helper to determine tag based on score
export function getTagFromScore(score: number): ScoreTag {
  for (const tier of scoreConfig.tags) {
    if (score >= tier.min) return tier.tag;
  }
  return "Fair";
}

// Helper to get commentary based on score tier
export function getCommentary(reportData: any, score: number): string {

  const learner = reportData?.lenUsername;

  if (score >= 9) {
    return `Exceptional work, ${learner}! You've demonstrated impressive capability across all four leadership skills—goal setting, delegation, giving feedback and conflict management—showing real strength in how you create clarity, empower your team and navigate difficult conversations. You approach leadership not just as task delivery, but as a way to align people, build confidence and move teams toward results. Continue leading with this balance and intention. You have what it takes to create real impact through the people you lead.`;
  }
  if (score >= 7) {
    return `Great performance, ${learner}! You're making meaningful progress across all four leadership skills—goal setting, delegation, giving feedback and conflict management—and building a strong foundation for effective people leadership. You've demonstrated good decision-making in several situations, with strengths emerging in how you set direction, communicate expectations and respond in the moment. The next step is to make these behaviours more consistent by asking yourself what the sharper leadership move would be in key moments. You are well on your way to becoming a confident and impact-driven people leader.`;
  }
  return `Good start, ${learner}! You handled a number of situations well across the four leadership skills—goal setting, delegation, giving feedback and conflict management—and your results show real potential to grow. With more practice, you can bring greater clarity, consistency and confidence to the moments that matter most. You're building leadership capability with every step, and you have the potential to grow into a more intentional and effective leader. Your leadership journey is just beginning, and your best moves are still ahead.`;
}

// Sample data for demonstration (checklists and takeaways are now in separate files)
export const sampleLearnerData: LearnerReport = {
  title: "Effective People Leader",
  overallScore: 7.2,
  commentary: getCommentary({ lenUsername: "Alex Chen" }, 7.2),
  competencies: [
    { name: "Goal Setting", icon: "🎯", score: 9.2, tag: "Pro" },
    { name: "Delegation", icon: "📋", score: 6.5, tag: "Fair" },
    { name: "Giving Feedback", icon: "💬", score: 7.6, tag: "Skilled" },
    { name: "Conflict Management", icon: "⚔️", score: 5.4, tag: "Fair" },
  ],
};
